import { Row, Col, Button, Checkbox, Spin, Image, Tooltip } from 'antd';
import UseConsents from "../hooks/useConsents";
import { useTranslation } from 'react-i18next';

const Consents = ({
  reservation,
  patientToAdmission,
  setPatientToAdmission,
  currentStep,
  setCurrentStep,
  countryCode,
}) => {

  const {
    loading,
    patientConsents,
    checkConsent,
    showConsentPopup,
    showBasicSign,
    handleNextStep,
    signers,
    disableSignButton,
  } = UseConsents(
    reservation,
    patientToAdmission,
    setPatientToAdmission,
    currentStep,
    setCurrentStep,
    countryCode,
  );
  const { t } = useTranslation();

  return (
    <Row justify="center" className="admission-settings__consents mt-50 mb-50">
      <Col lg={16} xs={22}>
        <Row>
          <p>{t('admissionPage.consents.patient')}:
            <strong className='ml-5'>
              {patientToAdmission && `${patientToAdmission.userFirstName} ${patientToAdmission.userLastName}`}
            </strong>
          </p>

        </Row>
        <Row justify="center" className='mt-10'>
          {
            loading ?
              <Spin className="cmt-spin margin-top" />
              :
              patientConsents?.map((item, index) => {
                return (
                  <Col lg={24} xs={24} key={index} className="consent-item p-30 mb-15">
                    <Row justify="space-between">
                      <Col>
                        <p className="text-title mb-20">{item.title}</p>
                      </Col>
                      <Col>
                        <Row>
                          <Col>
                            <p className='mr-15'>Completado</p>
                          </Col>
                          <Col>
                            <Checkbox className='checkbox' checked={item.signed} onChange={
                              (e) => checkConsent(e.target.checked, index)
                            } />
                          </Col>
                        </Row>
                        <Col>
                          {
                            item.signerType &&
                            <Image
                              preview={false}
                              width={120}
                              className={(item.signed) ? 'signer-type' : 'none'}
                              src={signers[item.signerType]}
                            />
                          }
                        </Col>
                      </Col>
                    </Row>
                    <Row>
                      <p className='mb-30'>{item.description}</p>
                    </Row>
                    <Row justify="center">
                      <Col lg={7} xs={24} className="mr-20">
                        <Button
                          loading={loading}
                          onClick={() => showConsentPopup(index, item.signed, item.type, 'show')}
                          className="cmt-button tertiary outline"
                          type="primary"
                          size='large'
                        >
                          Mostrar consentimiento
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                )
              })
          }
        </Row>
      </Col>
      <Col lg={16} xs={22} className='mt-30'>
        <Row justify="space-between" gutter={[0, 20]}>
          {
            patientConsents ?
              <Tooltip
                title="Debe seleccionar al menos un consentimiento para poder firmar"
                placement="top"
                color="#223A70"
                open={disableSignButton}
              >
                <Col xl={4} lg={5} xs={24}>
                  <Button
                    onClick={() => showBasicSign(0, true, 'basic', 'signer')}
                    disabled={disableSignButton}
                    className={`cmt-button ${disableSignButton ? 'disabled' : ''}`}
                    type="primary"
                    size="large"
                    block
                  >
                    Firmar
                  </Button>
                </Col>
              </Tooltip>
              : <Col></Col>
          }
          <Col xl={4} lg={5} xs={24}>
            <Button
              onClick={handleNextStep}
              className="cmt-button primary"
              type="primary"
              size="large"
              block
            >
              Siguiente
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Consents;
